import { Image } from "./image";
import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useHydrated } from "../hooks/useHydrated";

export const Gallery = (props) => {
  const galleryRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const hydrated = useHydrated();

  // Breakpoints live in slick config rather than a windowWidth state, so the
  // markup is identical on the prerendered HTML and after hydration.
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2 } },
      { breakpoint: 800, settings: { slidesToShow: 1 } },
    ],
  };

  useEffect(() => {
    const handleScroll = () => {
      if (galleryRef.current) {
        const rect = galleryRef.current.getBoundingClientRect();
        setIsActive(rect.top <= 500);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div id="case-studies" className="text-center" ref={galleryRef}>
      <div className="container">
        <div className="section-title">
          <h2>Case studies</h2>
          <p>
            A selection of products we've designed, built, and shipped for
            clients across healthcare, real estate, customer support, finance,
            fitness, and fleet management.
          </p>
        </div>
        <div className="row">
          <div className={`portfolio-items ${isActive ? 'portfolio-items-active' : ''}`}>
            {props.data ? (
              <Slider key={hydrated ? "client" : "prerender"} {...settings}>
                {props.data.map((d, i) => (
                  <Image
                    key={`${d.title}-${i}`}
                    title={d.title}
                    largeImage={d.largeImage}
                    smallImage={d.smallImage}
                    text={d.text}
                    id={d.id}
                    slug={d.slug}
                    category={d.category}
                    industry={d.industry}
                    platform={d.platform}
                  />
                ))}
              </Slider>
            ) : (
              "Loading..."
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
